import { api } from "../apiCore";
import { invalidateByPrefix } from '../apiCache';

export function addFirmwarePackage(data) {
    const url = `/firmware/package`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.putForm(url, form);
}

export function uploadRouterFirmware(data) {
    const url = `/router/firmware`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.putForm(url, form);
}

export function saveWebfleetCredentials(data) {
    const url = `/external_service/webfleet/account`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.putForm(url, form).then((res) => {
        invalidateByPrefix('company_by_id:');
        return res;
    });
}

export function pairWebfleet(data) {
    const url = `/external_service/webfleet/pair`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.putForm(url, form).then((res) => {
        invalidateByPrefix('company_by_id:');
        return res;
    });
}

export function saveIturanCredentials(data) {
    const url = `/external_service/ituran/account`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.putForm(url, form).then((res) => {
        invalidateByPrefix('company_by_id:');
        return res;
    });
}

export function saveWexCredentials(data) {
    const url = `/wex/companies/${data.company_id}/credentials`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.postForm(url, form).then((res) => {
        invalidateByPrefix('company_by_id:');
        return res;
    });
}

export function pairIturan(data) {
    const url = `/external_service/ituran/pair`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.putForm(url, form).then((res) => {
        invalidateByPrefix('company_by_id:');
        return res;
    });
}

export function deleteExternalRelation(data) {
    const url = `/external_service/${data.externalType}/account`;

    const form = new FormData();
    form.append('company_id', data.company_id)

    return api.delete(url, {
        data: form
    }).then((res) => {
        invalidateByPrefix('company_by_id:');
        return res;
    });
}

export function deleteFirmware(data) {
    let url = `/firmware/package/${data.id}`;

    return api.delete(url);
}

export function deleteRouterFirmware(data) {
    let url = `/router/firmware`;

    const form = new FormData();
    form.append('version', data.version)

    return api.delete(url, {
        data: form
    });
}

export function updateVersion(data) {
    const url = `/version`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.postForm(url, form);
}

export function sendCompanyKey(data) {
    const url = `/installerapp/companykey/send`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.postForm(url, form);
}

export function regenerateCompanyKey(data) {
    const url = `/installerapp/companykey/regenerate`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.postForm(url, form);
}

export function getInstallerAppDevice(data) {
    const { deviceId } = data;
    let url = `/installerapp/device/${deviceId}`;

    return api.get(url);
}

export function updateDevicesProfile(data) {
    const { profile_id, ...rest } = data;
    let url = `/profile/${profile_id}/devices/config`;

    const form = new FormData();
    for (let key in rest) {
        form.append(key, rest[key])
    }

    return api.postForm(url, form);
}

export function setProfileProps(data) {
    const { profile_id, ...rest } = data;
    let url = `/profiles/${profile_id}`;

    const form = new FormData();
    for (let key in rest) {
        form.append(key, rest[key])
    }

    return api.postForm(url, form).then((res) => {
        invalidateByPrefix('profiles:');
        return res;
    });
}

export function saveGlobalDataThreshold(data) {
    const url = `/global_tags`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.postForm(url, form);
}

export function getGlobalDataTags() {
    const url = `/global_tags`;

    return api.get(url);
}

export function liveVideoLog(data) {
    const url = `/elasticsearch/log`;

    const form = new FormData();
    for (let key in data) {
        form.append(key, data[key])
    }

    return api.postForm(url, form);
}

export function cancelRouterLogs(data) {
    let url = `/router/${data.imei}/logs/cancel`;

    return api.postForm(url);
}

export function restartRouter(data) {
    let url = `/router/${data.imei}/restart`;

    return api.postForm(url);
}

export function uploadRouterConfig(data) {
    const { imei, ...rest } = data;
    const url = `/router/${imei}/config`;

    const form = new FormData();
    for (let key in rest) {
        form.append(key, rest[key])
    }

    return api.postForm(url);
}

export function routerFirmwareUpload(data) {
    const { imei, ...rest } = data;
    const url = `/router/${imei}/firmware`;

    const form = new FormData();
    for (let key in rest) {
        form.append(key, rest[key])
    }

    return api.postForm(url);
}

export function getProfilesConfigs(data) {
    let params = '';
    for (const key in data) {
        params += `${(!params ? '?' : '&')}${key}=${data[key]}`
    }
    let url = `/profiles/default_profile_settings${params}`;

    return api.get(url);
}

export function getIturanCredentials(data) {
    let params = '';
    for (const key in data) {
        params += `${(!params ? '?' : '&')}${key}=${data[key]}`
    }
    let url = `/external_service/ituran/account${params}`;

    return api.get(url);
}

export function getWebfleetCredentials(data) {
    let params = '';
    for (const key in data) {
        params += `${(!params ? '?' : '&')}${key}=${data[key]}`
    }
    let url = `/external_service/webfleet/account${params}`;

    return api.get(url);
}

export function getWebfleetDevice(data) {
    const { serial_number } = data;
    const url = `/external_service/webfleet/device/${serial_number}`;

    return api.get(url);
}

export function getDeviceById(data) {
    const { device_id, ...rest } = data;

    let params = '';
    for (const key in rest) {
        params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
    }
    const url = `/devices/${device_id}${params}`;

    return api.get(url);
}

export function getDeviceUsage(data) {
    const { device_id, ...rest } = data;

    let params = '';
    for (const key in rest) {
        params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
    }
    const url = `/devices/${device_id}/usage${params}`;

    return api.get(url);
}

export function getStatsHistory(data) {
    let params = '';
    for (const key in data) {
        params += `${(!params ? '?' : '&')}${key}=${data[key]}`
    }
    const url = `/system_admin/stats/history${params}`;

    return api.get(url);
}

export function getStatsDuration(data) {
    let params = '';
    for (const key in data) {
        params += `${(!params ? '?' : '&')}${key}=${data[key]}`
    }
    const url = `/system_admin/stats/socket/duration${params}`;

    return api.get(url);
}

export function getRouterLogs(data) {
    const { imei, ...rest } = data;

    let params = '';
    for (const key in rest) {
        params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
    }

    const url = `/router/${imei}/logs${params}`;

    return api.get(url);
}

export function getRouterFirmware() {
    const url = `/router/firmware/list`;

    return api.get(url);
}

export function getRouterConfig(data) {
    const { imei } = data;
    const url = `/router/${imei}/config`;

    return api.get(url);
}

export function getProfileHistory(data) {
    const { id } = data;
    let url = `/profiles/${id}/history`;

    return api.get(url);
}
export function getCustomUsersPermissions() {
    const url = `/custom_users/permissions/categories`;

    return api.get(url);
}

export function getTelemetryHistory(data) {
    const { imei, ...rest } = data;

    let params = '';
    for (const key in rest) {
        params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
    }

    const url = `/router/${imei}/telemetry/history${params}`;

    return api.get(url);
}
